import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const ContactUsBanner: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        background: 'linear-gradient(to right, #e0f2ff, #f5faff)',
      }}
    >
      <Box
        sx={{
          maxWidth: 1200,
          mx: 'auto',
          py: 1,
          px: { xs: 2, sm: 4 },
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
          borderRadius: 2,
          textAlign: { xs: 'center', md: 'left' },
        }}
      >
        <Typography
          variant="h6"
          fontWeight={500}
          fontFamily={"'Playfair Display', Georgia, serif"}
          sx={{ maxWidth: 600 }}
        >
          Ready to take your logistics strategy to the next level?
        </Typography>

        <Button
          variant="contained"
          color="primary"
          href="#contact-banner"
          sx={{
            borderRadius: '999px',
            textTransform: 'none',
            whiteSpace: 'nowrap',
            px: 4,
          }}
        >
          Contact Us
        </Button>
      </Box>
    </Box>
  );
};

export default ContactUsBanner;
